import React from 'react';
import { formatTravelBooking, formatTravelBookingList } from 'selectors/travel.selectors';
import BookingFormInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    format: formatTravelBookingList,
    columns: [
      {
        title: 'Booking No',
        dataIndex: 'reference_number',
        width: '300px',
        sorter: true
      },
      {
        title: 'Route',
        dataIndex: 'leg__route__name',
        width: '210px',
        sorter: true,
        render: (text, record) => record.leg.route.name
      },
      {
        title: 'Reference',
        dataIndex: 'leg__reference_number',
        width: '330px',
        sorter: true,
        render: (text, record) => record.leg.reference_number
      },
      {
        title: 'Depart',
        dataIndex: 'departure_date',
        width: '240px',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => (record.departure_date && record.departure_date.isValid() ? record.departure_date.format('DD-MM-YYYY HH:mm') : 'N/A')
      },
      {
        title: 'Arrive',
        dataIndex: 'arrival_date',
        width: '240px',
        sorter: true,
        render: (text, record) => (record.arrival_date && record.arrival_date.isValid() ? record.arrival_date.format('DD-MM-YYYY HH:mm') : 'N/A')
      },
      {
        title: 'Status',
        dataIndex: 'status__name',
        width: '200px',
        sorter: true,
        render: (text, record) => record.status.name
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the booking associated with this user ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'departure_date',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      reference_number: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['reference_number'],
        searchValue: ''
      },
      leg__reference_number: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['leg__reference_number'],
        searchValue: ''
      },
      leg__route__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['leg__route__name'],
        searchValue: ''
      },
      status__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['status__name'],
        searchValue: ''
      }
    },
    // General
    title: 'Bookings',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    format: formatTravelBooking,
    emptyMessage: 'Please select a Record',
    title: 'Booking',
    component: props => (
      <BookingFormInput
        {...props}
        inputFormItemLayout={{
          inputLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 }
            }
          },
          summaryLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 4 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 20 }
            }
          },
          row: {
            gutter: 16
          },
          col: {
            span: 12
          }
        }}
        title="Booking"
      />
    )
  }
};

export default config;
